import * as filtersSelectionActions from "app/action_types/users_filters_selection_action_types";

/* app analysis module */

export const countryFilterSelected = (selectedCountry: number) => {
    return {
        type: filtersSelectionActions.COUNTRY_SELECTION,
        selectedCountry,
    };
};

export const durationFilterSelected = (selectedDuration: string) => {
    return {
        type: filtersSelectionActions.DURATION_SELECTION,
        selectedDuration,
    };
};

const webSourceFilterSelected = (selectedWebSource: string) => {
    return {
        type: filtersSelectionActions.WEB_SOURCE_SELECTION,
        selectedWebSource,
    };
};

export const onFilterChangedEducationalTooltipPresented = () => {
    return {
        type: filtersSelectionActions.EDUCATIONAL_FILTER_WAS_PRESENTED,
    };
};

/* website, keyword analysis module in DigitalSuite */

export const countryFilterDSSelected = (selectedCountry: number) => {
    return {
        type: filtersSelectionActions.DIGITAL_SUITE_COUNTRY_SELECTION,
        selectedCountry,
    };
};

export const openCountryFilterDSSelected = (selectedCountry?: number) => {
    return {
        type: filtersSelectionActions.DIGITAL_SUITE_OPEN_COUNTRY_SELECTION,
        selectedCountry,
    };
};

export const durationFilterDSSelected = (selectedDuration: string) => {
    return {
        type: filtersSelectionActions.DIGITAL_SUITE_DURATION_SELECTION,
        selectedDuration,
    };
};

export const webSourceFilterDSSelected = (selectedWebSource: string) => {
    return {
        type: filtersSelectionActions.DIGITAL_SUITE_WEB_SOURCE_SELECTION,
        selectedWebSource,
    };
};

export const isStillNewSession = (isNewSession: boolean) => {
    return {
        type: filtersSelectionActions.IS_NEW_SESSION,
        isNewSession,
    };
};
